<template>
  <div v-if="localCustomer" class="friendinfo">
    <div class="row">
      <div class="col-12">
        <!-- friend wish section -->
        <div class="row">
          <div class="col">
            <h3>{{ $t('customerForm.netFriendNeed') }}</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <span class="cap-label">{{
              $t('customerForm.netFriendNeeds')
            }}</span>
            <br />
            <span class="sub">{{
              $t('customerForm.netFriendNeedSubtext')
            }}</span>
            <br /><br />
            <checkboxlist
              v-model="localCustomer.friendNeeds"
              :list="friendNeeds"
              :rows="3"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <sprtextarea
              v-model="localCustomer.description"
              :title="$t('customerForm.netDescriptionTitle')"
              :rows="6"
              :subtext="$t('customerForm.netDescription')"
            />
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="buttons">
          <prevnextbuttons @prev="onPrevClicked" @next="onNextClicked" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import * as _ from 'lodash'
import sprtextarea from '../SPRSimpleTextArea.vue'
import checkboxlist from '../SPRSimpleCheckboxBitmaskList.vue'
import prevnextbuttons from '../SPRPrevNextButtons.vue'
import { FriendCustomerNetDto } from '@/types/index'
import { SprCheckboxBitmaskValue, SprCheckboxValue } from '@/types/custom'
import inpututils from '@/mixins/inpututils'
import bitmaskhelper from '@/helpers/bitmaskhelper'

// the data object
export interface TemplateComponentData {
  localCustomer: FriendCustomerNetDto | undefined
  pressedNext: boolean
}

export default Vue.extend({
  name: 'NetFriendNeed',
  components: { sprtextarea, checkboxlist, prevnextbuttons },
  mixins: [inpututils],
  props: {
    customer: {
      type: Object as () => FriendCustomerNetDto,
      required: true
    }
  },
  data(): TemplateComponentData {
    return {
      localCustomer: undefined,
      pressedNext: false
    }
  },
  computed: {
    friendNeeds() {
      var self = this
      return _.map(this.$store.state.friendNeeds, function (val) {
        return {
          value: val.id,
          text: self.$t('friendNeeds.' + val.text),
          selected: bitmaskhelper
            .bitmaskToArray(self.customer.friendNeeds)
            .includes(val.id)
        }
      }).filter((x) => x.value !== 0)
    }
  },
  mounted(): void {
    this.localCustomer = this.customer
  },
  methods: {
    onPrevClicked(): void {
      this.$emit('prev', this.localCustomer)
    },
    onNextClicked(): void {
      this.pressedNext = true

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$emit('next', this.localCustomer)
        }
      })
    }
  }
})
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_variables.scss';

.validation {
  box-sizing: border-box;
  color: #cc0000;
  background: #ffffff;
  display: inline-block;
  position: relative;
  align-content: center;
  flex-flow: row;
  border-radius: 5px;
  max-width: 500px;
  width: 100%;
  padding: 10px;
  margin: 0;
}
.friendinfo {
  background-color: $brand-white;
  padding: 15px;
  padding-top: 30px;

  .headertitle {
    margin-bottom: 30px;
  }

  .cap-label {
    color: $brand-red;
    padding: 0 0;
  }

  .buttons {
    padding-top: 30px;
  }
}
</style>
